module.exports = __webpack_public_path__ + "static/media/galerija_2014 (28).42f805d0.jpg";